var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSlashBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8921 9.19922L1.67517 0.078125C1.54387 -0.0390625 1.35629 0 1.24375 0.117188L1.05618 0.371094C0.962388 0.507812 0.981146 0.703125 1.11245 0.800781L12.3294 9.94141C12.4419 10.0391 12.6482 10.0195 12.742 9.88281L12.9296 9.64844C13.0421 9.51172 13.0046 9.31641 12.8921 9.19922ZM7.00227 0.9375C7.97765 0.9375 8.80298 1.79688 8.80298 2.8125C8.80298 3.37891 8.55913 3.86719 8.20274 4.19922L8.91552 4.78516C9.40322 4.27734 9.70333 3.59375 9.70333 2.8125C9.70333 1.26953 8.4841 0 7.00227 0C6.02688 0 5.1828 0.546875 4.69511 1.34766L5.40789 1.93359C5.72677 1.34766 6.30825 0.9375 7.00227 0.9375ZM3.70097 9.0625V8.57422C3.70097 7.63672 4.41375 6.875 5.3141 6.875C5.38913 6.875 5.48292 6.91406 5.61422 6.95312C6.0644 7.10938 6.53333 7.1875 7.00227 7.1875C7.15233 7.1875 7.28363 7.16797 7.43369 7.14844L6.1957 6.15234C6.10191 6.11328 6.00813 6.09375 5.91434 6.07422C5.72677 5.99609 5.52044 5.95703 5.3141 5.95703C3.92606 5.9375 2.80061 7.12891 2.80061 8.57422V9.0625C2.80061 9.58984 3.19452 10 3.70097 10H10.3036C10.4724 10 10.6224 9.96094 10.7725 9.86328L9.79712 9.0625H3.70097Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSlashBlack);
export default __webpack_public_path__ + "static/media/user-slash-black.fad102b8.svg";
export { ForwardRef as ReactComponent };